window._ = require('lodash');
window.Popper = require('popper.js').default;

let ClipboardJS = require('clipboard');
new ClipboardJS('.btn-clipboard');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

function check_webp_feature(feature, callback) {
    var kTestImages = {
        lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
        lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
        alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
        animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
    };
    var img = new Image();
    img.onload = function () {
        var result = (img.width > 0) && (img.height > 0);
        callback(feature, result);
    };
    img.onerror = function () {
        callback(feature, false);
    };
    img.src = "data:image/webp;base64," + kTestImages[feature];
}

/**
 * If page contains scorm-session meta tag, Axios and jQuery will attach it as X-SCORM-SESSION header.
 * This allows us to embed trainings to iframes in cross domain context.
 */
let scormSession= null;
try {
    if(window.top.location.origin !== window.location.origin) {
        scormSession = document.head.querySelector('meta[name="scorm-session"]');
    }
} catch(e) {
    scormSession = document.head.querySelector('meta[name="scorm-session"]');
}

try {
    window.$ = window.jQuery = require('jquery');

    if (scormSession) {
        window.$.ajaxSetup({
            beforeSend: function(xhr) {
                xhr.setRequestHeader('X-SCORM-SESSION', scormSession.content);
            }
        });
    }

    require('bootstrap');

    $(document).ready(function() {
        check_webp_feature('lossy', (feature, result) => {
            if (result === false && $('section[data-background-jpg]') !== null) {
                $('section[data-background-jpg]').each(function (){
                    const fallbackImage = $(this).data('background-jpg');
                    $(this).css('background-image', `url(${fallbackImage})`);
                });
            }
        });

        if (location.hash) {
            $("a[href='" + location.hash + "']").tab("show");
        }
        $(document.body).on("click", "a[data-toggle]", function(event) {
            const hash = this.getAttribute("href");
            if(history.pushState) {
                history.pushState(null, null, hash);
            }
            else {
                location.hash = hash;
            }
        });
    });
    $(window).on("popstate", function() {
        var anchor = location.hash || $("a[data-toggle='tab']").first().attr("href");
        $("a[href='" + anchor + "']").tab("show");
    });
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience, so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

if (scormSession) {
    window.axios.defaults.headers.common['X-SCORM-SESSION'] = scormSession.content;
}

require('promise-polyfill');

window.swal = require('sweetalert');

/* POLYFILL */
(function templatePolyfill(d) {
    if('content' in d.createElement('template')) {
        return false;
    }

    var qPlates = d.getElementsByTagName('template'),
        plateLen = qPlates.length,
        elPlate,
        qContent,
        contentLen,
        docContent;

    for(var x=0; x<plateLen; ++x) {
        elPlate = qPlates[x];
        qContent = elPlate.childNodes;
        contentLen = qContent.length;
        docContent = d.createDocumentFragment();

        while(qContent[0]) {
            docContent.appendChild(qContent[0]);
        }

        elPlate.content = docContent;
    }
})(document);

import bsBreakpoints from 'bs-breakpoints';

window.xclose = function() {try{window.API.LMSFinish('');return;}catch(e){};try{window.API_1484_11.Terminate('');return;}catch(e){};}
window.openWorld = function() {}